import React, {Component} from 'react';
import Styles from './style.css';
import Header from "../../components/header/component";
import cx from "classnames";
import * as Icon from "react-feather";
import Footer from "../../components/footer/component";
import ContactForm from "../../components/contact-form/component";
import ProjectOdd from "../../components/project-odd/component";
import ProjectEqual from "../../components/project-equal/component";
import Chat from "../../components/chat/component";

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className={Styles.app}>
                <Chat/>
                <Header view={"/"} props={this.props}/>
                <div className={Styles.sectionTwo}>
                    <ProjectEqual
                        name={"Build Assured"}
                        title={"Inspection First. Payment Second."}
                        description={"Build Assured provides transparency and financial protection at every stage of the build."}
                        large={"60%"}
                        medium={"70%"}
                        small={"90%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776632958/swedish%20tech%20mafia/BuildAssured_Logotype_Inv_ko5py8.svg"}
                        website_link={"https://www.build-assured.com"}
                        first_color={"#2C3E50"}
                        second_color={"#3A6187"}
                    />
                    <ProjectOdd
                        name={"Proptree"}
                        title={"Real Estate Link-in-bio"}
                        description={"Proptree is the world's first CRM-enriched link-in-bio for real estate."}
                        large={"50%"}
                        medium={"60%"}
                        small={"80%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1754847078/swedish%20tech%20mafia/Proptree_Logotype_RGB_White_2_chhunj.png"}
                        website_link={"https://proptr.ee"}
                        first_color={"#6B7EE3"}
                        second_color={"#94A5FF"}
                    />
                    <ProjectEqual
                        name={"Escrow Made Easy"}
                        title={"Escrow Made Easy"}
                        description={"Escrow Made Easy is an all-in-one platform designed for seamless initiation, transaction, exchange and deal."}
                        large={"40%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1728054061/swedish%20tech%20mafia/EME_Logotype_vertical_RGB_white_white_tbyolj.png"}
                        website_link={"https://escrowmadeeasy.com"}
                        first_color={"#0D9E81"}
                        second_color={"#16D3AD"}
                    />
                    <ProjectOdd
                        name={"INVTD"}
                        title={"private banking fintech"}
                        description={"INVTD specializes in private banking solutions that are not for everyone."}
                        large={"50%"}
                        medium={"60%"}
                        small={"80%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1728055252/swedish%20tech%20mafia/INVTD_logo_ygsrxq.png"}
                        website_link={"https://invtd.com"}
                        first_color={"#121212"}
                        second_color={"#121212"}
                    />
                    <ProjectEqual
                        name={"adBooster"}
                        title={"adtech for bulk"}
                        description={"adBooster is an adtech company serving high volume advertisers within real estate, hospitality, automotive and other verticals."}
                        large={"50%"}
                        medium={"60%"}
                        small={"80%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1660398523/swedish%20tech%20mafia/Adbooster_Logotype_RGB_White_f78m3r.png"}
                        website_link={"https://adbooster.ai"}
                        first_color={"#667EEA"}
                        second_color={"#66A6EA"}
                    />
                    <ProjectOdd
                        name={"Property Booster"}
                        title={"Property Listings Supercharged"}
                        description={"Property Booster is on a mission to boost property listings with leading adtech."}
                        large={"60%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776628194/swedish%20tech%20mafia/Propertybooster_Logotype_RGB_White_xmmyt4.png"}
                        video_link={"https://primehit-public.s3.eu-central-1.amazonaws.com/PROMO_Onboarding_3_AE-EN.mp4"}
                        website_link={"https://www.propertybooster.io"}
                        first_color={"#33B8CF"}
                        second_color={"#2CDCEA"}
                    />
                    <ProjectEqual
                        name={"adBop"}
                        title={"Online Ads Simplified"}
                        description={"adBop is an one-stop-shop for online advertisers without prior marketing skills, simply advertise across multiple channels – including Facebook, Google, Instagram and many more."}
                        large={"40%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776628194/swedish%20tech%20mafia/adbop-logo_z6m1fk.svg"}
                        website_link={"https://adbop.com"}
                        first_color={"#41CBC7"}
                        second_color={"#3AE4CD"}
                    />
                    <ProjectOdd
                        name={"Klearing"}
                        title={"Smart global payments"}
                        description={"Klearing is a global trade platform designed for people."}
                        large={"50%"}
                        medium={"60%"}
                        small={"80%"}
                        logo_link={require("../../assets/images/klearing_logo.svg")}
                        website_link={"https://klearing.com"}
                        first_color={"#121212"}
                        second_color={"#121212"}
                    />
                    <ProjectEqual
                        name={"saleschannel"}
                        title={"Your Branded Saleschannel"}
                        description={"Saleschannel makes it easy to sell campaigns in bulk across leading ad platforms, without the admin."}
                        large={"60%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776628194/swedish%20tech%20mafia/saleschannel_Logotype_RGB_White_ubnbim.png"}
                        website_link={"https://www.saleschannel.io"}
                        first_color={"#41CBC7"}
                        second_color={"#3AE4CD"}
                    />
                    <ProjectOdd
                        name={"Boosta Bostad"}
                        title={"Property Listings Supercharged"}
                        description={"Boosta Bostad is on a mission to boost property listings with leading adtech."}
                        large={"60%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1660399607/swedish%20tech%20mafia/Boostabostad_Logotype_RGB_White_dj8liq.png"}
                        website_link={"https://www.boostabostad.se"}
                        first_color={"#7FCD5B"}
                        second_color={"#96FF5A"}
                    />
                    <ProjectEqual
                        name={"NINA ZANDNIA"}
                        title={"Fashion House Digitalized"}
                        description={"Nina Zandnia a digital fashion house combining traditional know-how with today’s online technologies."}
                        large={"30%"}
                        medium={"30%"}
                        small={"50%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1776628980/swedish%20tech%20mafia/NinaZandia_Logo_Initials_Inv_bdnrnb.svg"}
                        video_link={"https://youtu.be/LmHDE8uLfjk?si=sURDWuWRjXyQQa8O"}
                        website_link={"https://www.ninazandnia.com"}
                        first_color={"#3F1738"}
                        second_color={"#821C6F"}
                    />
                    <ProjectOdd
                        name={"Pink Piñata"}
                        title={"On-trend Women's Fashion"}
                        description={"Pink Piñata is online boutique with a wide collection of styles with new added daily."}
                        large={"60%"}
                        medium={"45%"}
                        small={"70%"}
                        logo_link={"https://res.cloudinary.com/propertybooster/image/upload/v1660399970/swedish%20tech%20mafia/pp_logo_white_b9igtv.png"}
                        video_link={"https://www.youtube.com/channel/UC6xcjUQ2LMvy6XhoLusTxWg/videos"}
                        website_link={"https://www.pinkpinata.store"}
                        first_color={"#C89995"}
                        second_color={"#EAC4BF"}
                    />

                </div>
                <ContactForm/>
                <Footer props={this.props}/>
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/pages/home/component.js